import { View } from "../../../../../../core/view/index";
import { Template } from "../../../../../../core/template/index";
import ReceiveQuantityModal from "../../../modals/receive_quantity/index";
import ShelveModal from "../../../modals/shelve/index";


export class ShelveItemView extends View {

    template = Template.lazy('/app/views/package_tracking/receive/partials/shelve_item/index.html');

    shelfTextHolder: HTMLElement;
    shelfText: HTMLElement;
    item: any;

    public onShelveClick(event: MouseEvent)
    {
        event.preventDefault();
        new ShelveModal(this).showIn(this.app);
    }

    public onShelved(shelf: string)
    {
        this.data.shelf = shelf;
        if (shelf) {
            this.shelfTextHolder.classList.remove('hidden');
            this.shelfText.textContent = shelf;
            this.element.classList.add('done');
        } else {
            this.shelfTextHolder.classList.add('hidden');
            this.element.classList.remove('done');
        }
        this.trigger('shelved');
    }
}